import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { FormModal } from '@ztechapps/webui.form'
import { UnitOfMeasureAddProvider, useUnitOfMeasureAddContext } from './Context'

export const AddNew = () => {
  return (
    <UnitOfMeasureAddProvider>
      <AddNewFormModal />
    </UnitOfMeasureAddProvider>
  )
}

const AddNewFormModal = () => {
  const { initialValues, onSubmit, validate, components } = useUnitOfMeasureAddContext()

  return (
    <FormModal
      {...{
        trigger: ({ onClick }) => {
          return (
            <BusyButton
              title={'Add new unit of measure'}
              text={'Add New...'}
              onClick={onClick}
              bsStyle={'primary'}
              icon={'plus'}
            />
          )
        },
        initialValues,
        onSubmit,
        title: 'Add new unit of measure',
        validate,
      }}
    >
      <components.formInput />
    </FormModal>
  )
}
